import { useMemo, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import * as RoleHelper from "../../../../helpers/RoleHelper";
import CustomBreadCrumbs from "../../../common/breadcrumbs";
import { SelectButton } from "primereact/selectbutton";
import LearningPathwayList from "../../learningPathways/list";
import AudienceList from "../../audiences/list";
import { AccessScopeConstants } from "../../../../constants";

const AssignmentList = ({ labels, user }) => {
  const navigate = useNavigate();

  const intl = useIntl();
  const items = useMemo(() => {
    const { role } = user || {};

    const canReadLPs = RoleHelper.checkRoleScope(
      role?.scope,
      AccessScopeConstants.ContentAccess,
      AccessScopeConstants.ReadScope
    );

    const canReadAuds = RoleHelper.checkRoleScope(
      role?.scope,
      AccessScopeConstants.UserAccess,
      AccessScopeConstants.ReadScope
    );

    const items = [];
    if (canReadLPs) {
      items.push({
        label: intl.formatMessage({ id: "by_learning_programs" }),
        value: "LP",
      });
    }
    if (canReadAuds) {
      items.push({
        label: intl.formatMessage({ id: "by_audiences" }),
        value: "AUD",
      });
    }
    return items;
  }, [user]);

  const [activeTab, setActiveTab] = useState(items[0]?.value);

  return (
    <div>
      <CustomBreadCrumbs labels={labels} navigate={navigate} />
      <div className="edexlms-page-content">
        <div className="edexlms-page-header flex-column sm:flex-row gap-2 align-items-start">
          <div className="edexlms-page-title">
            {intl.formatMessage({ id: "assignments" })}
          </div>
          <div className="edexlms-page-actions">
            <SelectButton
              value={activeTab}
              onChange={(e) => setActiveTab(e.value)}
              options={items}
            />
          </div>
        </div>
        <div className="edexlms-page-body">
          {(activeTab === "LP" && (
            <LearningPathwayList isFromAssigment={true} />
          )) ||
            null}
          {(activeTab === "AUD" && <AudienceList isFromAssigment={true} />) ||
            null}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state?.self?.user,
});

export default connect(mapStateToProps)(AssignmentList);
